//====================================== DesktopVersion ====================================
// import seal_explore_1 from "../../Images/Explore/seal/seal_explore_1.jpg";
// import sealion7_explore_1 from "../../Images/Explore/sealion7/sealion7_explore_1.jpg";
import destroyer_05_explore from "../../Images/Explore/DesktopVersion/destroyer_05_explore.jpg";
import dolphin_explore from "../../Images/Explore/DesktopVersion/dolphin_explore.jpg";
import sea_lion_05_dmi_explore from "../../Images/Explore/DesktopVersion/sea_lion_05_dmi_explore.jpg";
import seal_06_dmi_explore from "../../Images/Explore/DesktopVersion/seal_06_dmi_explore.jpg";
import song_plus_dmi_explore from "../../Images/Explore/DesktopVersion/song_plus_dmi_explore.jpg";  
import song_pro_explore from "../../Images/Explore/DesktopVersion/song_pro_explore.jpg";  
import seagull_explore from "../../Images/Explore/DesktopVersion/seagull_explore.png";

//====================================== MobileVersion ====================================
// import seal_explore_1_mob from "../../Images/Explore/seal/seal_explore_1_mob.jpg";
// import sealion7_explore_1_mob from "../../Images/Explore/sealion7/sealion7_explore_1_mob.jpg";
import destroyer_05_explore_mob from "../../Images/Explore/MobileVersion/destroyer_05_explore_mob.jpg";
import dolphin_explore_mob from "../../Images/Explore/MobileVersion/dolphin_explore_mob.png";
import sea_lion_05_dmi_explore_mob from "../../Images/Explore/MobileVersion/sea_lion_05_dmi_explore_mob.jpg";
import seal_06_dmi_explore_mob from "../../Images/Explore/MobileVersion/seal_06_dmi_explore_mob.jpg";
import song_plus_dmi_explore_mob from "../../Images/Explore/MobileVersion/song_plus_dmi_explore_mob.jpg";
import song_pro_explore_mob from "../../Images/Explore/MobileVersion/song_pro_explore_mob.png";
import seagull_explore_mob from "../../Images/Explore/MobileVersion/seagull_explore_mob.jpg";

// ============================================================================
// ВРЕМЕННО ОТКЛЮЧЕНО: PDF функциональность
// Для восстановления PDF кнопок замените все "pdfFileName: null" на соответствующие имена файлов:
// - "BYD Song PLUS DM-i.pdf"
// - "BYD Destroyer 05 (2024).pdf" 
// - "BYD Dolphin (2025).pdf"
// - "BYD Sea Lion 05 (2025).pdf"
// - "BYD Seal 06.pdf"
// - "BYD Song Song Pro.pdf"
// - "BYD Seagull (2024).pdf"
// ============================================================================

export const carModelsExplore = [
  {
    id: 1,
    pdfFileName: null, // Временно отключено
    firstContent: {
      img: song_plus_dmi_explore,
      img_mob: song_plus_dmi_explore_mob,
      data: [
        {
          option: 160,
          type: "km",
          description: "electric_range",
        },
        {
          option: 7.7,
          type: "s",
          description: "0_100km_h_acceleration",
        },
        {
          option: "3.88 / 100km",
          type: "",
          description: "fuel_consumption",
        },
      ],
    },
  },
  {
    id: 2,
    pdfFileName: null, // Временно отключено
    firstContent: {
      img: destroyer_05_explore,
      img_mob: destroyer_05_explore_mob,
      data: [
        {
          option: 120,
          type: "km",
          description: "electric_range",
        },
        {
          option: 7.3,
          type: "s",
          description: "0_100km_h_acceleration",
        },
        {
          option: "3.8 / 100",
          type: "km",
          description: "fuel_consumption",
        },
      ],
    },
  },
  {
    id: 3,
    pdfFileName: null, // Временно отключено
    firstContent: {
      img: dolphin_explore,
      img_mob: dolphin_explore_mob,
      data: [
        {
          option: 520,
          type: "km",
          description: "electric_range",
        },
        {
          option: 10.9,
          type: "s",
          description: "0_100km_h_acceleration",
        },
        {
          option: "10.5 kWh / 100 km",
          type: "",
          description: "energy_consumption",
        },
      ],
    },
  },
  {
    id: 4,
    pdfFileName: null, // Временно отключено
    firstContent: {
      img: sea_lion_05_dmi_explore,
      img_mob: sea_lion_05_dmi_explore_mob,
      data: [
        {
          option: 115,
          type: "km",
          description: "electric_range",
        },
        {
          option: 8.5,
          type: "s",
          description: "0_100km_h_acceleration",
        },
        {
          option: "3.79 / 100 km",
          type: "",
          description: "fuel_consumption",
        },
      ],
    },
  },
  {
    id: 5,
    pdfFileName: null, // Временно отключено
    firstContent: {
      img: seal_06_dmi_explore,
      img_mob: seal_06_dmi_explore_mob,
      data: [
        {
          option: 120,
          type: "km",
          description: "electric_range",
        },
        {
          option: 7.9,
          type: "s",
          description: "0_100km_h_acceleration",
        },
        {
          option: "2.91 / 100km",
          type: "",
          description: "fuel_consumption",
        },
      ],
    },
  }, 
  {
    id: 6,
    pdfFileName: null, // Временно отключено
    firstContent: {
      img: song_pro_explore,
      img_mob: song_pro_explore_mob,
      data: [
        {
          option: 115,
          type: "km",
          description: "electric_range",
        },
        {
          option: 8.5,
          type: "s",
          description: "0_100km_h_acceleration",
        },
        {
          option: "15.8 kWh / 100km",
          type: "",
          description: "energy_consumption",
        },
      ],
    },
  },
  {
    id: 7,
    pdfFileName: null, // Временно отключено
    firstContent: {
      img: seagull_explore,
      img_mob: seagull_explore_mob,
      data: [
        {
          option: 420,
          type: "km",
          description: "electric_range",
        },
        {
          option: 13,
          type: "s",
          description: "0_100km_h_acceleration",
        },
        {
          option: "9.9 kWh / 100km",
          type: "",
          description: "energy_consumption",
        },
      ],
    },
  },
];
